export default "__VITE_ASSET__UcAR$dYB__"